import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  Select,
} from '@chakra-ui/react'
import { FindAddressResult, PersonAdditionalData } from 'BrokerTsLib/src/dtos'
import { SelectionType } from 'BrokerTsLib/src/enums'
import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { FormGroup } from '../components/FormGroup'
import { FormLabel } from '../components/FormLabel'
import { FormSpacer } from '../components/FormSpacer'
import { InputGroup } from '../components/InputGroup'
import { useSelections, useUrl } from '../hooks'
import { useNameof } from '../hooks/useNameof'
import { useGetAres } from '../hooks/useUser'
import { Cloud } from '../icons'
import { insuranceParamsContext } from '../layouts/Wizard'
import { InsureeName } from './InsureeName'
import { padLeft } from 'BrokerTsLib/src/helpers/global'
import axios from 'axios'


export const ICOOptions = ({ personPrefix, disabled, showAgent, hideIc }: { personPrefix: string, disabled?: boolean, showAgent?: boolean, hideIc?: boolean }) => {
  const { insuranceParams } = useContext(insuranceParamsContext)
  const isContracted = !!insuranceParams?.generalParams.contractNumber
  const isDisabled = isContracted || disabled

  const url = useUrl()

  const pnameof = useNameof<PersonAdditionalData>(personPrefix)
  const { register, watch, getFieldState, setValue, trigger, getValues } = useFormContext()
  const { data: dataTitles, isLoading: isLoadingTitles, isFetching: isFetchingTitles } = useSelections(SelectionType.TitleBefore)

  const icPath = pnameof(x => x.idendificationNumber)
  const cnPath = pnameof(x => x.companyName)
  const tbPath = pnameof(x => x.agent!.titleBefore)

  const ic = watch(icPath)
  const showIc = !hideIc

  const { data: aresData, refetch: loadAres, isLoading, isFetching } = useGetAres(ic, {
    enabled: false,
    onSuccess: (({ data }) => {
      let ulice = data.adresaUlice
      if (!ulice) {
        ulice = !data.adresaCastObce ? data.adresaCastObce : data.adresaObec
      }
      // todo - přímé volání axios asi není optimální, ale prozatím funkční
      axios.get<FindAddressResult[]>(`${url}/FindAddress?street=${ulice}&searchQuery=${data.adresaCislo}`).
        then(resp => {
          if (resp.data) {
            const pscFiltered = resp.data.filter(d => d.psc == data.adresaPsc);
            if (pscFiltered.length == 1) {
              const item = pscFiltered[0]
              setValue(pnameof(x => x.address.addressPoint), item.adresniMisto)
              setValue(pnameof(x => x.address.street), item.ulice)
              let cp = item.cisloDomovni
              if (item.cisloOrientacni) {
                cp = cp + '/' + item.cisloOrientacni
              }
              setValue(pnameof(x => x.address.houseNumber), cp)
              setValue(pnameof(x => x.address.postCode), item.psc)
              let obec = item.obec
              if (item.castObce && item.castObce != item.obec) {
                obec = obec + ' - ' + item.castObce
              }
              setValue(pnameof(x => x.address.city), obec)

              trigger(pnameof(x => x.address.street))
              trigger(pnameof(x => x.address.houseNumber))
              trigger(pnameof(x => x.address.postCode))
              trigger(pnameof(x => x.address.city))
            }
          }
        })

      setValue(pnameof(x => x.companyName), data.nazev)
      trigger(pnameof(x => x.companyName))
    })
  })

  return (
    <Box sx={{ display: 'grid', gap: 1 }}>
      <Flex>
        <FormGroup>

          <Flex sx={{ columnGap: 8, rowGap: 2, flexWrap: 'wrap', alignItems: 'start' }}>

            {showIc &&
              <FormControl isInvalid={!!getFieldState(icPath).error} isRequired>
                <FormLabel htmlFor="bcn">
                  IČO
                </FormLabel>

                <InputGroup
                  isDisabled={isDisabled}
                  id="bcn"
                  placeholder="Např. 18628443"
                  htmlSize={16}
                  errors={getFieldState(icPath).error}
                  {...register(icPath, {
                    onBlur: (e: any) => {
                      const val = e.target.value
                      setValue(icPath, !!val ? padLeft(val, 8, '0') : null) // doplneni zleva nulama
                    }
                  })}
                />
              </FormControl>
            }

            <FormControl isInvalid={!!getFieldState(cnPath).error} isRequired>
              <FormLabel htmlFor="bcn">
                Název firmy
              </FormLabel>

              <InputGroup
                isDisabled={isDisabled}
                id="bcn"
                htmlSize={16}
                errors={getFieldState(cnPath).error}
                {...register(cnPath)}
              />
            </FormControl>

            {showIc &&
              <FormControl isInvalid={!!aresData?.data.errorMessage} >
                <FormLabel>&nbsp;</FormLabel>

                {!isDisabled &&
                  <Button
                    type="button"
                    variant="outline"
                    isLoading={isLoading || isFetching}
                    isDisabled={isLoading || isFetching || !ic}
                    onClick={() => loadAres()}>
                    <Cloud color="secondary.500" />
                    Načíst údaje
                  </Button>
                }

                {aresData?.data.errorMessage && !isLoading && !isFetching && (
                  <FormErrorMessage>IČ nenalezeno.</FormErrorMessage>
                )}
              </FormControl>
            }
          </Flex>
        </FormGroup>

      </Flex>

      {showAgent /*&& type == Selection.Company*/ &&
        < Box display='grid'>
          <FormSpacer />
          <FormSpacer />
          <FormLabel fontWeight='bold'>Jednatel / zástupce</FormLabel>
          <FormSpacer />

          <FormGroup>
            <FormControl>
              <FormLabel>Titul před jménem</FormLabel>

              {(dataTitles?.data.length ?? 0) > 0 &&
                <Select
                  {...register(tbPath)}
                  isDisabled={isContracted}
                  defaultValue={getValues(tbPath) ?? ''}
                >
                  <option value='' disabled>Vyberte</option>
                  {dataTitles?.data.map((item) => (
                    <option value={item.value?.toString()} key={item.id}>{item.value}</option>
                  ))}
                </Select>
              }
            </FormControl>

            <InsureeName personPrefix={pnameof(x => x.agent)} isDisabled={isContracted} />
          </FormGroup>
        </Box>
      }
    </Box >
  )
}